import styled from "styled-components";
import { colors } from "../../../utils/styled/_variables.styled";

export const MenuContainer = styled.div`

  .menu-icon-link{
    color: #079D56;
    margin-left: 29px;

    @media (min-width: 769px) {
      margin-left: 20px;
    }

    .menu-icon {
      width: 24px;
      height: 24px;
      cursor: pointer;

      @media (min-width: 769px) {
        width: 44px;
        height: 44px;
      }
    }

}

.nav-menu {
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  bottom: 0px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;


  @media (min-width: 769px) {
    bottom: unset;
    height: 661px;
    top: 100px;
    width: 463px;
    border-radius: 12px;
    left: 40px;
  }

}

.nav-menu ul {
  list-style: none;
  padding: 0;
}

.nav-menu li {
  padding: 10px 20px;

  a{
    color: #5D615F;
    font-family: 'Averta Std';
    font-size: 22px;
    font-weight: 700;
    line-height: 22px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    text-decoration: none;
    &:hover, &:focus {
      color: ${colors.greenLight}
    }
    @media (min-height: 900px) {
      font-size: 24px;
      line-height: 36px;
    }
  }
}

.menu-header{
  display: flex;
  justify-content: space-between;
  padding: 20px 20px;
  flex-direction: row-reverse;

  .close-icon {
    width: 24px;
    height: 24px;
  }
}

@media (orientation: landscape) {
  .nav-menu {
    height: 100%;
    @media (min-width: 992px) {
      height: 661px;
    }

    @media (max-height: 499px) {
      height: 375px;
    }
  }
  .nav-menu ul {
    overflow-y: auto;
    height: 200px;
    @media (min-width: 992px) {
      overflow-y: unset;
      height: unset;
    }
  }
  
  h3.modal__title{
    text-align: center !important;
  }
}
  .buttonReturn{
    visibility: collapse;
  }
`;
